export const UPLOAD_FILE = 'UPLOAD_FILE'
export const UPLOAD_FILE_START = 'UPLOAD_FILE_START'
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS'
export const UPLOAD_FILE_ERROR = 'UPLOAD_FILE_ERROR'
export const RESET_FILE_UPLOAD = 'RESET_FILE_UPLOAD'

export const ADD_MEDIA_FILE_TO_NOTE = 'ADD_MEDIA_FILE_TO_NOTE'
export const ADD_MEDIA_FILE_TO_NOTE_START = 'ADD_MEDIA_FILE_TO_NOTE_START'
export const ADD_MEDIA_FILE_TO_NOTE_SUCCESS = 'ADD_MEDIA_FILE_TO_NOTE_SUCCESS'
export const ADD_MEDIA_FILE_TO_NOTE_ERROR = 'ADD_MEDIA_FILE_TO_NOTE_ERROR'
